import React, { Component } from 'react';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import ViewQuestionAnswerSectionMiddle from '../components/viewquestion_answer/ViewQuestionAnswerSectionMiddle';
import * as compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import * as Cookies from "es-cookie";
import { Row, Col, Container } from 'react-bootstrap'


const FETCH_SESSION_DATA = gql`
  query(
          $mobile: String!, $exam_session_id: ID) {
            getStudentExamSessions(mobile: $mobile, exam_session_id: $exam_session_id){
              id
              correct
              wrong
              not_answered
              total_questions
              correct_marks
              negative_marks
              total_marks
              in_time
              less_time
              over_time
              accuracy
              speed
              type
              sub_type
            
              exam_type
              qtype_report{
                question_type
                question_type_name
                correct
                wrong
                not_answered
                accuracy
              }
              error_report{
                error
                error_name
                count
              }
              result_questions{
                
                id
                question
                option1
                option2
                option3
                option4
                subject
                explanation
                answer
                section
                status
                slno
                qtype
                compquestion
                list1type
                list2type
                mat_question
                inputquestion
                attempt_answer
                reason_for_wrong
                comments
                
              }
              timestamp
            
          }
      }
`;

const FETCH_GLOBALS = gql` 
query($mobile: String) {
    studentGlobals(mobile: $mobile){
        reports{
            id
            report
        }
        errorReasons{
            id
            reason
          }
        
    }
}
`;

class ViewQuestionAndAnswer extends Component {

    render() {
        console.log("ffffff", this.props.history.location.state);

        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        const getStudentExamSessions = this.props.getStudentExamSessions;
        const loading1 = getStudentExamSessions.loading;
        const error1 = getStudentExamSessions.error;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        const studentGlobals = this.props.studentGlobals;
        const loading2 = studentGlobals.loading;
        const error2 = studentGlobals.error;

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        return (
            <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
                {
                    loading1 ?
                        (
                            <Container><Row className="my-3">
                                <Col>
                                    <div class="spinner-border text-primary text-center loading-img-center"></div>
                                </Col>
                            </Row></Container>
                        )
                        :
                        (
                            <>
                                {
                                    getStudentExamSessions.getStudentExamSessions.length > 0 ? (
                                        <ViewQuestionAnswerSectionMiddle
                                            locdata={this.props.history.location.state}
                                            changeToggle={this.menuToggler}
                                            getData={getStudentExamSessions.getStudentExamSessions[0]}
                                            getStudentExamSessions={getStudentExamSessions.getStudentExamSessions[0]?.result_questions}
                                            studentGlobals={studentGlobals.studentGlobals}
                                        />
                                    ) : (
                                        <Row>
                                            <Col sm={12}>
                                                <div className='text-center h5 text-success'>No data found</div>
                                            </Col>
                                        </Row>
                                    )
                                }
                            </>
                        )
                }
            </div>
        );
    }
}

// export default ViewQuestionAndAnswer;

export default
    withRouter(
        compose(graphql(FETCH_SESSION_DATA,
            {
                options: props => ({
                    variables: {
                        mobile: props.history.location.state.mobile,
                        exam_session_id: parseInt(props.history.location.state.sessionid),
                    },
                    fetchPolicy: "no-cache"
                }), name: "getStudentExamSessions"
            }),
            graphql(FETCH_GLOBALS, {
                options: (props) => ({
                    variables: {
                        mobile: props.history.location.state.mobile
                    }
                    ,
                    fetchPolicy: "no-cache"
                }),
                name: "studentGlobals"
            })
        )(ViewQuestionAndAnswer));
